import { createRouter, createWebHistory } from 'vue-router'
import Catalog from '../views/Catalog.vue'

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    {
      path: '/:catalog/c/:category+/',
      name: 'category',
      component: Catalog,
    },
    {
      path: '/:catalog/b/:brand/:category*/',
      name: 'brand',
      component: Catalog,
    },
  ]
})

export default router